import { FC, useEffect, useState } from 'react';

import { ToggleBubble, ToggleWrapper } from './simpleToggle.sc';

interface Props {
  initial?: boolean;
  onChange?: (isToggled: boolean) => void;
}

const SimpleToggle: FC<Props> = props => {
  const [isToggled, setIsToggled] = useState(!!props.initial);

  useEffect(() => {
    if (props.initial !== undefined) {
      setIsToggled(props.initial);
    }
  }, [props.initial]);

  const onChange = () => {
    setIsToggled(t => !t);
    if (props.onChange) {
      props.onChange(!isToggled);
    }
  };

  return (
    <ToggleWrapper onClick={onChange}>
      <ToggleBubble $isToggled={isToggled} />
    </ToggleWrapper>
  );
};

export default SimpleToggle;
